"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureAreaListResponseSchema = exports.LeisureAreaSchema = exports.LeisureAreaParamsSchema = void 0;
var zod_1 = require("zod");
exports.LeisureAreaParamsSchema = zod_1.z.object({
    category: zod_1.z.number().optional(),
});
exports.LeisureAreaSchema = zod_1.z.object({
    no: zod_1.z.number(),
    title: zod_1.z.string(),
    desc: zod_1.z.string().optional(),
    available: zod_1.z.boolean(),
});
exports.LeisureAreaListResponseSchema = zod_1.z.array(exports.LeisureAreaSchema);
